import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import {
  generateDailyReport,
  getDailyReport,
  getDailyReports,
} from "api/dailyReportApi"
import { usePaginatedResource } from "./useCrudResource"

export const DAILY_REPORT_QUERY_KEY = "daily-reports"

export const useDailyReports = (params = {}, enabled = true) =>
  usePaginatedResource(DAILY_REPORT_QUERY_KEY, getDailyReports, params, enabled)

export const useDailyReport = (id, enabled = true) =>
  useQuery({
    queryKey: [DAILY_REPORT_QUERY_KEY, "view", id],
    queryFn: () => getDailyReport(id),
    enabled: !!id && enabled,
  })

export const useGenerateDailyReport = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: generateDailyReport,
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: [DAILY_REPORT_QUERY_KEY, "all"] }),
  })
}
